var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "NsTextField",
    _vm._g(
      {
        attrs: {
          id: _vm.id,
          clearable: _vm.clearable,
          disabled: _vm.disabled,
          icon: _vm.icon,
          label: _vm.label,
          name: _vm.name,
          placeholder: _vm.placeholder,
          type: _vm.type,
          value: _vm.value
        },
        on: { keydown: _vm.handleKeydown, focus: _vm.handleFocus },
        model: {
          value: _vm.currency,
          callback: function($$v) {
            _vm.currency = $$v
          },
          expression: "currency"
        }
      },
      _vm.$listeners
    ),
    [
      _vm._t("default", [
        _vm._v("\n    " + _vm._s(_vm.$slots.default) + "\n  ")
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }